import { render } from "./SEOPage.vue?vue&type=template&id=4ed07c4f&scoped=true"
import script from "./SEOPage.vue?vue&type=script&lang=js"
export * from "./SEOPage.vue?vue&type=script&lang=js"

import "./SEOPage.vue?vue&type=style&index=0&id=4ed07c4f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed07c4f"]])

export default __exports__